<div
  role="rowheader"
  class="sticky left-0 z-10 flex w-36 shrink-0 items-center gap-2 border-r border-steel-10 bg-white px-3 py-4 md:min-w-48 md:grow md:basis-0"
  [class.font-semibold]="!indented()"
>
  @if (indented()) {
    <span aria-hidden="true" class="ms-3 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-50 md:ms-7" data-id="comparison-table-row-bullet"></span>
  }
  {{ label() }}
</div>

<ng-content />
